import { Instruction } from "@/backend/services/reordering";
import { FusaReply } from "./replyTypes";

export enum Status {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  ABORTED = 'ABORTED',
  DEVIATED = 'DEVIATED'
}

export interface ContainerParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  parentId: string;
  position: number;
  title?: string;
  containerType: ContainerTypes;
  isScaffold: boolean;
  sourceId?: string;
  sourceType?: SourceTypes;
  status?: Status;
  description?: string;
  rangeParameterId?: string;
  skipParameterId?: string;
  skipKeyId?: string;
  rootId: string;
  rootType: ROOT_TYPES;
  parentType: PARENT_TYPES;
  conditionalFieldId?: string;
  /** The org of the container's root. ContainerAccess sets it on create from the root; callers never choose it. */
  propelOrgId?: string;
}

export interface ContainerCreateParams extends Omit<ContainerParams, 'id' | 'createdAt' | 'updatedAt'> {
  selectedScenarioId?: string;
}

export interface StepParams extends ContainerParams {
  selectedScenarioId?: string;
}

export enum ROOT_TYPES {
  PROCEDURE = 'procedure',
  BLOCK = 'block',
  IMPLEMENTATION_FUNCTION = 'implementationFunction',
}

export enum PARENT_TYPES {
  CONTAINER = 'container',
  PROCEDURE = 'procedure',
  BLOCK = 'block',
  IMPLEMENTATION_FUNCTION = 'implementationFunction',
}

export enum ContainerTypes {
  Step = 'step',
  Section = 'section',
  Scenario = 'scenario',
  RepeatingStep = 'repeatingStep',
  RepeatingStepChild = 'repeatingStepChild',
  FunctionCall = 'functionCall',
}

export const STEP_TYPES = [ContainerTypes.Step, ContainerTypes.RepeatingStep, ContainerTypes.RepeatingStepChild];

export interface ContainerInterface extends ContainerParams {
  createdAt: Date;
  updatedAt: Date;
  title: string;
  isScaffold: boolean;
  sourceId: string;
  sourceType?: SourceTypes;
  status: Status;
  description: string;
  rootId: string;
  rootType: ROOT_TYPES;
  parentType: PARENT_TYPES;
  rangeParameterId: string;
  skipParameterId: string;
  skipKeyId: string;
  conditionalFieldId: string;
};

export interface StepInterface extends ContainerInterface {
  selectedScenarioId?: string;
}

export type SelectedScenario = {
  id: string;
  stepId: string;
  scenarioId: string;
};

export enum SourceTypes {
  Scaffold = 'SCAFFOLD',
  Block = 'BLOCK'
}

export interface ContainerReply extends FusaReply  {
  container?: ContainerInterface;
}

export interface CreateContainerRequest {
  container: ContainerCreateParams;
}

export interface UpdateContainerRequest {
  container: ContainerInterface | StepInterface;
  hideToast?: boolean;
}

export interface ContainersReply extends FusaReply {
  containers: ContainerInterface[];
}

export interface ContainerOrderRequest {
  containers: ContainerInterface[];
}

export interface ReorderRequest {
  movingContainerId: string
  targetContainerId: string
  instruction: Instruction;
}

export interface ReorderReply extends FusaReply {
  targetContainers: ContainerInterface[];
  movingContainerSiblings: ContainerInterface[];
}

export interface SaveContainerBlockRequest {
  container: ContainerParams;
  blockTitle: string
}